import React, { useState } from "react";
import "./styles.less";
import { useTranslation } from "react-i18next";
// import { Link } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import classNames from "classnames";
import { Link } from "../../components/LinkIcon";

export const Card = (props) => {
  const {
    name,
    descript,
    icon,
    bgImg,
    them,
    link,
    currentIndex,
    keyIndex,
  } = props;
  const { t } = useTranslation();
  return (
    <div className={classNames("app-card", them)}>
      <div className="title-warp">
        <div className="icon">
          <img src={icon} alt="authing" />
        </div>
        <div className="name">{name}</div>
      </div>
      <div className="descript">{descript}</div>
      {currentIndex === keyIndex && (
        <div className="button-warp">
          <a href={`/apn/detail/${link}`}>
            <span className="button-text">{t("marketplace.banner.get")}</span>
            <i
              className="icon authing-icon authing-arrow-down-line"
              style={{ transform: "rotate(90deg)", display: "inline-block" }}
            ></i>
          </a>
        </div>
      )}

      <div className="bgimg">
        <img src={bgImg} alt="authing" />
      </div>
    </div>
  );
};
export const SampleNextArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        display: "block",
        width: "400px",
        height: "240px",
        right: 40,
        top: 150,
      }}
      onClick={onClick}
    />
  );
};

export const SamplePrevArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        display: "block",
        width: "400px",
        height: "240px",
        left: 40,
        top: 150,
        zIndex: 2,
      }}
      onClick={onClick}
    />
  );
};
export const MarketplaceBanner = () => {
  const { t } = useTranslation();
  const [currentIndex, setCurrentIndex] = useState(0);
  var settings = {
    dots: true,
    autoplay: true,
    className: "center",
    centerMode: true,
    infinite: true,
    centerPadding: "0px",
    slidesToShow: 3,
    // slidesToScroll: 3,
    speed: 500,
    dotsClass: "dots-style",
    nextArrow: <SampleNextArrow className="nextArrow" />,
    prevArrow: <SamplePrevArrow />,
    beforeChange: (old, index) => {
      setCurrentIndex(index);
    },
  };
  const cards = [
    {
      name: t("marketplace.banner.card1.name"),
      descript: t("marketplace.banner.card1.descript"),
      icon:
        "//files.authing.co/authing-website/marketplace-icon-feish-white.png",
      bgImg:
        "//files.authing.co/authing-website/marketplace-icon-white-feishu.png",
      them: "blue",
      link: "lark",
      keyIndex: 0,
    },
    {
      name: t("marketplace.banner.card2.name"),
      descript: t("marketplace.banner.card2.descript"),
      icon: "//files.authing.co/authing-website/marketplace-icon-aws-white.png",
      bgImg:
        "//files.authing.co/authing-website/marketplace-icon-white-aws.png",
      them: "yellow",
      link: "aws-china",
      keyIndex: 1,
    },
    {
      name: t("marketplace.banner.card3.name"),
      descript: t("marketplace.banner.card3.descript"),
      icon: "//files.authing.co/authing-website/marketplace-icon-ali-white.png",
      bgImg:
        "//files.authing.co/authing-website/marketplace-icon-white-aliyun.png",
      them: "green",
      link: "aliyun-user-sso",
      keyIndex: 2,
    },
    {
      name: t("marketplace.banner.card4.name"),
      descript: t("marketplace.banner.card4.descript"),
      icon:
        "//files.authing.co/authing-website/marketplace-icon-huawei-white.png",
      bgImg:
        "//files.authing.co/authing-website/marketplace-icon-white-huawei.png",
      them: "red",
      link: "huaweicloud",
      keyIndex: 3,
    },
  ];
  return (
    <div className="marketplace-banner">
      <div className="inner">
        <h1 className="title">{t("marketplace.banner.title")}</h1>
        <div className="subtitle">{t("marketplace.banner.subtitle")}</div>
        {/* <Link to="/apn/intro" className="link">
          <span className="text">{t("marketplace.banner.intro")}</span>
          <i
            className="icon authing-icon authing-arrow-down-line"
            style={{ transform: "rotate(90deg)", display: "inline-block" }}
          ></i>
        </Link> */}
        <Link href="/apn/intro">{t("marketplace.banner.intro")}</Link>

        <div>
          <Slider {...settings}>
            {cards.map((item) => (
              <div>
                <Card currentIndex={currentIndex} {...item} />
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
};
